import { Box } from '@mui/material';
import Modal from '@mui/material/Modal';
import * as React from 'react';
import Button from '../../../../../../components/Button/Button';
import { useAppSelector } from '../../../../../../reduxService/hooks';
import { conversionLabel, convertTo, EConversionSIToImperial } from '../../../../../conversion';
import { UnitOfMeasure } from '../../../../../enum/project';
import { modalStyle } from '../../../../../style/modal';
import * as BeMaccaferriStoreHelper from '../../../../../api/store/BeMaccaferriStoreHelper';
import { IModalSoilVelocityProps } from './IModalSoilVelocity';
import './ModalSoilVelocity.scss';
import { useTranslation } from 'react-i18next';
import { selectProject } from '../../../../selector/conversion';
import { MaterialPreviewResponseWithSoilVelocity } from '../../../../../api/IApiResponse';
import { selectProjectInfo } from '../../../../../store/projectInfo/projectInfoSlice';
import { roundToTwo } from '../../Geometry/utils';

const ModalSoilVelocity = (props: IModalSoilVelocityProps) => {
    const { t } = useTranslation();
    const project = useAppSelector(selectProject);
    const projectInfo = useAppSelector(selectProjectInfo);
    const unitOfMeasure = projectInfo.data?.unitOfMeasure;
    const [velocity, setVelocity] = React.useState<number | undefined>(project.data?.hydraulicData?.soilAdmissibleVelocity);
    const [materials, setMaterials] = React.useState<MaterialPreviewResponseWithSoilVelocity[]>([]);

    React.useEffect(() => {
        const fetchNaturalMaterial = async () => {
            const naturalMaterials = await BeMaccaferriStoreHelper.getNaturalSoilMaterialsWithVelocityAsync();
            setMaterials(naturalMaterials.data);
        };
        fetchNaturalMaterial();
    }, []);

    const handleClick = (velocity: number) => {
        setVelocity(velocity);
    };

    const handleClose = () => {
        props.onClose(velocity!);
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <Box sx={{ ...modalStyle, width: '400px' }}>
                <h4>{t('hydraulic_data_modal_soil_title')}</h4>
                <div className='border border-1'>
                    <div className='d-flex justify-content-evenly'>
                        <h6>{t('hydraulic_data_modal_soil_soil')}</h6>
                        <h6>{t('hydraulic_data_modal_soil_velocity')}</h6>
                    </div>
                    {materials
                        .filter(material => material.velocity > 0)
                        .map((material, index) => {
                            let _velocity = unitOfMeasure == UnitOfMeasure.SI ? material.velocity :roundToTwo(convertTo(material.velocity, EConversionSIToImperial.ms_to_fts));
                            return (
                                <button className='d-flex justify-content-between w-100 border-0 soil-item' onClick={() => handleClick(_velocity)} key={index}>
                                    <div>{material.name}</div>
                                    <div>{_velocity}</div>
                                </button>
                            );
                        })}
                </div>
                <div>
                    {t('hydraulic_data_modal_soil_result', { unit_measure: conversionLabel.ms_fts[projectInfo.data?.unitOfMeasure as number] })} <b>{velocity}</b>
                </div>
                <Button className='d-flex justify-content-end' onClick={handleClose}>
                    Ok
                </Button>
            </Box>
        </Modal>
    );
};

export default ModalSoilVelocity;
